import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { FNOLPATypeOfRepairPage } from 'gwce-capability-fnol-pa-react-ext';
import React from 'react';
import { withRouter } from 'react-router-dom';
import messages from '../../FNOLRT.messages';
import FNOLRTRepairFacilityPage from '../RepairFacility/FNOLRTRepairFacilityPage';
import FNOLRTRepairFacilityMapPage from '../RepairFacilityMap/FNOLRepairFacilityMapPage';

const repairFacility = {
    path: '/repair',
    component: FNOLRTRepairFacilityPage,
    title: messages.wizardPARepairFacility,
    stepProps: {
        template: WizardPageTemplateWithTitle,
    },
};

const repairFacilityMap = {
    path: '/repair',
    component: FNOLRTRepairFacilityMapPage,
    title: messages.wizardPARepairFacility,
    stepProps: {
        template: WizardPageTemplateWithTitle,
    },
};

function FNOLRTTypeOfRepairPage(props) {
    const extraProps = {
        repairFacility,
        repairFacilityMap,
        ...props
    }
    return <FNOLPATypeOfRepairPage {...extraProps} />;
}

FNOLRTTypeOfRepairPage.propTypes = wizardProps;
export default withRouter(FNOLRTTypeOfRepairPage);
